/* iceberg-ui */
import { DonutChart, PieChartEntry } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { popoverContentsColumns } from 'application/Shared/Components/Recharts/PopoverContents';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

const pieChartStyle = {
    height: '275px',
    marginLeft: '30px',
    marginRight: '30px'
};
const pieChartHeight = 250;

export const QBRPieChart = ({
    data,
    renderingScheduledReport,
    showPopover,
    title
}: {
    data: PieChartEntry[];
    keyPrefix: string;
    renderingScheduledReport: boolean;
    showPopover?: boolean;
    title: string;
}) => {
    const { t } = useTranslation();
    return (
        <Box style={pieChartStyle} mb="16px">
            <Typography variant="h5" style={{ marginBottom: '8px' }}>
                {title}
            </Typography>
            <DonutChart
                data={data}
                emptyMessage={t('Common.noData')}
                isAnimationActive={!renderingScheduledReport}
                popoverContentsColumns={popoverContentsColumns}
                responsiveContainerHeight={pieChartHeight}
                showPopover={showPopover}
            />
        </Box>
    );
};
